export const HIDE_JOU_KYC = "JOU_KYC";
export const HIDE_JOU_IND_PROFILE = "JOU_IND_PROFILE";
export const HIDE_JOU_FUND = "JOU_FUND";
export const HIDE_JOU_TRADING = "HIDE_JOU_TRADING";
export const HIDE_JOU_OPEN_ACCOUNT = "HIDE_JOU_OPEN_ACCOUNT";
export const HIDE_IB_JOU_IND_PROFILE = "IB_JOU_IND_PROFILE";
export const HIDE_IB_JOU_QUESTIONNAIRE = "HIDE_IB_JOU_QUESTIONNAIRE";
